const bearings = {
    '-180': 'W',
    '-168.75': 'WBN',
    '-157.5': 'WNW',
    '-146.25': 'NWBW',
    '-135': 'NW',
    '-123.75': 'NWBN',
    '-112.5': 'NNW',
    '-101.25': 'NBW',
    '-90': 'N',
    '-78.75': 'NBE',
    '-67.5': 'NNE',
    '-56.25': 'NEBN',
    '-45': 'NE',
    '-33.75': 'NEBE',
    '-22.5': 'ENE',
    '-11.25': 'EBN',
    '0': 'E',
    '11.25': 'EBS',
    '22.5': 'ESE',
    '33.75': 'SEBE',
    '45': 'SE',
    '56.25': 'SEBS',
    '67.5': 'SSE',
    '78.75': 'SBE',
    '90': 'S',
    '101.25': 'SBW',
    '112.5': 'SSW',
    '123.75': 'SWBS',
    '135': 'SW',
    '146.25': 'SWBW',
    '157.5': 'WSW',
    '168.75': 'WBS',
    '180': 'W'
};

module.exports = bearings;